import { useMemo } from 'react'
import { Box, Typography } from '@mui/material'
import CRMTable from '@/components/Table/CRM/CRMTable'
import CrmToast from '@/components/Table/CRM/CrmToast'
import NewTaskButton from '@/components/Table/CRM/NewTaskButton'
import TaskCreator from './TaskCreator'
import { useCRMStore } from '@/store/crm/crmStore'
import { useParams } from 'react-router-dom'
import { useAppTheme } from '@/theme/ThemeContext'
import { useCrmAccountId } from '@/hooks/useCrm'
import type { CrmFilterResource } from '@/services/crmService'
import { CRM_SECTIONS } from '@/utils/crm'

const ConsumerCRM = () => {
  // On the consumer route the id is the meter number. The sensor route
  // (/sensors/:sensorId/crm) has no meter number, so it shows the empty state.
  const { consumerId } = useParams()
  const meterNumber = consumerId?.trim() || undefined
  const accountId = useCrmAccountId()
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  const { crmTaskCreatorModal, setCRMTaskCreatorModal } = useCRMStore()

  const filters = useMemo<CrmFilterResource[]>(
    () =>
      meterNumber
        ? [{ name: 'meterNumber', value: [meterNumber], operator: 'EQUALS' }]
        : [],
    [meterNumber]
  )

  const handleClose = () => {
    setCRMTaskCreatorModal({ mode: null, open: false, data: null })
  }

  const handleOpen = () => {
    setCRMTaskCreatorModal({ open: true, mode: 'create', data: null })
  }

  if (!meterNumber || !accountId) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 300,
        }}
      >
        <Typography
          sx={{
            fontFamily: '"Rubik", sans-serif',
            fontSize: 18,
            fontWeight: 300,
            color: isDarkMode ? '#9CA3AF' : '#6B7280',
          }}
        >
          אין נתונים להצגה
        </Typography>
      </Box>
    )
  }

  return (
    <Box>
      <NewTaskButton onClick={handleOpen} />
      {CRM_SECTIONS.map(section => (
        <CRMTable
          key={section}
          type={section}
          accountId={accountId}
          filters={filters}
        />
      ))}
      <TaskCreator
        open={crmTaskCreatorModal.open}
        handleClose={handleClose}
        meterNumber={meterNumber}
      />
      <CrmToast />
    </Box>
  )
}

export default ConsumerCRM
